export const ottApps = [
  { id:"netflix", name:"Netflix", logo:"/allott/netflix.jpeg" },
  { id:"appletv", name:"Apple TV", logo:"/allott/appletv.jpeg" },
  { id:"altt", name:"ALTT", logo:"/allott/altt.jpeg" },
  { id:"jiocinema", name:"JioCinema", logo:"/allott/jiocinema.jpeg" },
  { id:"jiohotstar", name:"Jio Hotstar", logo:"/allott/jiohotstar.jpeg" },
  { id:"voot", name:"Voot", logo:"/allott/voot.jpeg" },
  { id:"vrotttv", name:"Vrott TV", logo:"/allott/vrotttv.jpeg" },
  { id:"disneyplus", name:"Disney+", logo:"/allott/disneyplus.jpeg" },
  { id:"distrotv", name:"DistroTV", logo:"/allott/distrotv.jpeg" },
  { id:"hoichoi", name:"Hoichoi", logo:"/allott/hoichoi.jpeg" },
  { id:"mxplayer", name:"MX Player", logo:"/allott/mxplayer.jpeg" },
  { id:"ottplay", name:"OTT Play", logo:"/allott/ottplay.jpeg" },
  { id:"playfix", name:"PlayFix", logo:"/allott/playfix.jpeg" }
];


const allMovies = [
  {
    id: 1,
    title: "Dhoom 3",
    poster: "/posters/3.jpeg",
    video: "/videos/dhoom3.mp4"
  },
  {
    id: 2,
    title: "Leo Return",
    poster: "/posters/2.jpeg",
    video: "/videos/leoreturn.mp4"
  },
  {
    id: 3,
    title: "Padma",
    poster: "/posters/3.jpg",
    video: "/videos/padma.mp4"
  },
  {
    id: 4,
    title: "Video 1",
    poster: "/posters/4.jpeg",
    video: "/videos/video1.mp4"
  }
];
export const movies = {
  netflix: allMovies,
  appletv: allMovies,
  altt: allMovies,
  jiocinema: allMovies,
  jiohotstar: allMovies,
  voot: allMovies,
  vrotttv: allMovies,
  disneyplus: allMovies,
  distrotv: allMovies,
  hoichoi: allMovies,
  mxplayer: allMovies,
  ottplay: allMovies,
  playfix: allMovies
};